import AppSpinner from "../../elements/AppSpinner";

const LoadingMergeItems = ({ loadingMessage }) => {
  return (
    <>
      <div
        className="d-flex flex-column justify-content-center align-items-center h1"
        style={{ height: "100" }}
      >
        {loadingMessage}
        <div className="mt-5">
          <AppSpinner size="xl" />
        </div>
      </div>
    </>
  );
};

export default LoadingMergeItems;
